"use client";

import classNames from "classnames";
import Link from "next/link";
import { FC } from "react";

import { Typography } from "@/shared/ui";
import InviteFriendsIcon from "@/svgs/invite_friends.svg";

import styles from "./profile-tabs.module.scss";
import { ProfileTabsTypes } from "./profile-tabs.types";

const TABS = [
  { label: "My Profile", value: "my-user", url: "/platform/profile" },
  { label: "Settings", value: "settings", url: "/platform/settings" },
];

const ProfileTabs: FC<ProfileTabsTypes> = ({ activeTab, withTheme }) => {
  return (
    <header className={classNames(styles.profileTabs, withTheme && styles.withTheme)}>
      <div className={styles.tabsContainer}>
        {TABS.map(({ label, value, url }) => (
          <Link
            key={value}
            type="button"
            href={url}
            className={classNames(styles.tabButton, value === activeTab && styles.active)}
          >
            <Typography variant="caption-1" className={styles.typo}>
              {label}
            </Typography>
          </Link>
        ))}
      </div>

      <Link href={"/platform/settings/invites"}>
        <InviteFriendsIcon className={styles.icon} />
      </Link>
    </header>
  );
};

export { ProfileTabs };
